import { useEffect, useContext } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { ProtectedRoute } from './ProtectedRoute'
import SignIn from '../pages/SignIn'
import PrimaryAntibodies from '../pages/Products/PrimaryAntibodies'
import AlexaFlourPrimary from '../pages/Products/AlexaFlourPrimary'
import AlexaFlourSecondary from '../pages/Products/AlexaFlourSecondary'
import Buffer from '../pages/Products/Buffer'
import Glass from '../pages/Products/Glass'
import MountingMedium from '../pages/Products/Mounting'
import Customers from '../pages/Customers'
import CustomersProfile from '../pages/Customers/CustomerProfile'
import OrderHistory from '../pages/OrderHistory'
import TeamBio from '../pages/TeamBio'
import AddProduct from '../pages/Products/AddProduct'
import Inventory from '../pages/Inventory'
import Thermofisher from '../pages/Thermofisher'
import Analytics from '../pages/Analytics'
import Error from '../pages/Error'
import Admins from '../pages/Admins'
import Roles from '../pages/Admins/Roles'
import NoAuth from '../pages/NoAuth'
import Templates from '../pages/Templates'
import TemplatesCategory from '../pages/TemplatesCategory'
import { AuthContext } from '../context/auth'
import { currentUserApi } from '../api'
import { getLocalStorage } from '../helpers/localStorage'
import { Loader } from "rsuite"

export const AppRouter = () => {
    const { login, logout, setIsLoading, isLoading } = useContext(AuthContext)
    const navigate = useNavigate()
    const token = getLocalStorage('identifynadmintoken')

    useEffect(() => {
        if (token) {
            setIsLoading(true)
            currentUserApi()
                .then(res => {
                    if (res.data) {
                        login(res.data)
                        // navigate('/products/primary-antibodies')
                        setIsLoading(false)
                    }
                })
                .catch(() => {
                    navigate('/')
                    logout()
                    setIsLoading(false)
                })
        } else {
            navigate('/')
            setIsLoading(false)
        }
    }, [])





    return (
        <>
            {isLoading && (
                <Loader size="lg" backdrop vertical />
            )}
            <Routes>
                <Route path='/' element={<SignIn />} />
                <Route element={<ProtectedRoute />}>
                    <Route path='/products/primary-antibodies' element={<PrimaryAntibodies />} />
                    <Route path='/products/alexa-fluor-primary' element={<AlexaFlourPrimary />} />
                    <Route path='/products/alexa-fluor-secondary' element={<AlexaFlourSecondary />} />
                    <Route path='/products/templates' element={<Templates />} />
                    <Route path='/products/templates-category' element={<TemplatesCategory />} />
                    {/* <Route path='/products/buffer' element={<Buffer />} />
                    <Route path='/products/glass' element={<Glass />} />
                    <Route path='/products/mounting' element={<MountingMedium />} /> */}
                    <Route path='/customers' element={<Customers />} />
                    <Route path='/customers/:id' element={<CustomersProfile />} />
                    <Route path='/order-history' element={<OrderHistory />} />
                    <Route path='/team-bio' element={<TeamBio />} />
                    <Route path='/inventory' element={<Inventory />} />
                    <Route path='/thermofisher' element={<Thermofisher />} />
                    <Route path='/admin/users' element={<Admins />} />
                    <Route path='/admin/roles' element={<Roles />} />
                    <Route path='/no-auth' element={<NoAuth />} />
                    <Route path='/analytics' element={<Analytics />} />
                    {/* <Route path='/products/add-product' element={<AddProduct/>}/> */}
                </Route>
                <Route path='*' element={<Error />} />
            </Routes>
        </>
    )
}
